export default "__VITE_ASSET__BXwYbz2O__"